import script from "./PrintWarehouseLocationLabelBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintWarehouseLocationLabelBtn.vue?vue&type=script&lang=ts&setup=true"

import "./PrintWarehouseLocationLabelBtn.vue?vue&type=style&index=0&id=03c1e662&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c1e662"]])

export default __exports__